<template>
  <section
    class="bg-white mx-auto mb-16 px-20 pt-12 pb-9 rounded-lg"
    style="max-width: 800px"
  >
    <form @submit="onSubmit">
      <div class="flex justify-between box-content flex-wrap">
        <RegistrationFormParts
          v-for="form in groupFormData"
          :key="form.id"
          :id="`target${form.id}`"
          :form="form"
          :formData="formData"
          :errors="errors"
          :hiddenItems="hiddenItems"
          @selectAll="selectAll"
        />
      </div>
      <div class="flex justify-center mb-9">
        <Field
          v-slot="{ field, handleChange }"
          type="checkbox"
          name="agree"
          :value="true"
          :validateOnMount="true"
        >
          <BaseCheckbox
            :field="field"
            name="agree"
            :value="true"
            :on-change="handleChange"
          >
            <a href="https://imitsu.jp/terms" target="_blank" class="border-b"
              >利用規約</a
            >、
            <a
              href="https://imitsu.jp/privacypolicy"
              target="_blank"
              class="border-b"
            >
              プライバシーポリシー
            </a>
            に同意する
          </BaseCheckbox>
        </Field>
      </div>
      <button
        type="submit"
        :disabled="Object.keys(errors).length > 0"
        class="block mx-auto mt-3 mb-8 bg-coral-main font-semibold text-white rounded focus:outline-none h-10"
        :class="[
          Object.keys(errors).length > 0
            ? 'bg-slate-300 cursor-not-allowed'
            : 'bg-coral-main hover:button',
        ]"
        style="width: 200px"
      >
        {{ hasNext ? '次へ' : 'この内容で登録する' }}
      </button>
    </form>
    <div class="text-center">
      <button
        class="inline-block text-gray-62 text-sm border-b focus:outline-none"
        @click="stepBack"
      >
        ひとつ前の項目に戻る
      </button>
    </div>
  </section>
</template>

<script>
import { reactive, computed, toRefs } from 'vue';
import { Field, useForm, useFormValues } from 'vee-validate';

import rules from '@/utils/validateRules.js';
import useFormValidation from '@/utils/composables/useFormValidation.js';
import BaseCheckbox from '@/components/form/BaseCheckbox.vue';
import RegistrationFormParts from '@/views/registration/RegistrationFormParts.vue';

export default {
  components: {
    Field,
    BaseCheckbox,
    RegistrationFormParts,
  },
  props: {
    formData: Object,
    hasNext: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-view', 'reset-hidden-item-input'],
  setup(props, { emit }) {
    const { groupFormData, validationSchema, detectHiddenItems } =
      useFormValidation({
        formData: props.formData,
        inputGroup: 'needs',
        initialSchema: {
          agree(value) {
            const result = rules.validate(value, 'required');
            return result === true || result;
          },
        },
      });

    const {
      handleSubmit,
      errors,
      setFieldValue,
      validateField,
      setFieldError,
    } = useForm({
      validationSchema,
      validateOnMount: true,
    });
    const values = useFormValues();

    const state = reactive({
      hiddenItems: computed(() => {
        const hiddenItems = detectHiddenItems(values.value);
        Object.entries(hiddenItems).forEach(([key, value]) => {
          if (value) return;
          setFieldError(`itemId${key}`, '');
        });

        return hiddenItems;
      }),
    });

    const selectAll = ({ name, value }) => {
      setFieldValue(name, value);
      validateField(name, value);
    };

    const stepBack = () => {
      emit('change-view', { view: 'step2', inputValues: values.value });
    };

    const onSubmit = handleSubmit((inputValues) => {
      const view = props.hasNext ? 'step4' : 'completed';
      emit('change-view', { view: view, inputValues });
    });

    return {
      ...toRefs(state),
      groupFormData,
      values,
      errors,
      selectAll,
      stepBack,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped></style>
